import styled, { keyframes } from 'styled-components';

import { colors } from 'theme/theme';

const tooltipColorVar = '--tooltip-color';

export const easeOut = 'cubic-bezier(0.215, 0.61, 0.355, 1)';

export const aGrow = keyframes`
  0% {
    transform: scaleY(0) translateZ(0);
  }
  100% {
    transform: scaleY(1) translateZ(0);
  }
`;

export const aChangeColor = (count: number) => keyframes`
  0% {
    background: ${colors.elementGrey};
  }
  ${50 / count}% {
    background: ${colors.brandGreen};
  }
  ${100 / count}% {
    background: ${colors.elementGrey};
  }
`;

export const CustomTooltip = styled.div<{ $color: string }>`
  ${tooltipColorVar}: ${(props) => props.$color};

  padding: 13px 16px;
  background: white;
  border: 1px solid var(${tooltipColorVar});
  box-shadow: 0 4px 9px rgb(0 0 0 / 10%);
  border-radius: 12px;
  color: ${colors.lightContentGrey};
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    bottom: -7px;
    border-bottom: 1px solid var(${tooltipColorVar});
    border-right: 1px solid var(${tooltipColorVar});
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    display: block;
    width: 12px;
    height: 12px;
    background: white;
  }
`;
